const HilightIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props}
	>
		<path d="M7 4.00006V1.00006M4 10.0001L2 12.0001M10 10.0001L12 12.0001M10 4.00006L12 2.00006M4 4.00006L2 2.00006M7 10.0001V13.0001M4 7.00006H1M10 7.00006H13" />
	</svg>
)

export default HilightIcon